import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Clock, XCircle, User, Lock } from 'lucide-react';
import { AuthShell, AuthField, PasswordField, AuthButton, AuthAlert } from '../components/auth/AuthShell';
import { useAuthStore } from '../store/auth';

type StatusNotice = { kind: 'pending' | 'rejected'; reason?: string } | null;

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading, authNotice } = useAuthStore();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // checkAuth chiqarib yuborgan bo'lsa, sababi shu yerda ko'rsatiladi.
  const shownError = error || authNotice || '';
  const [notice, setNotice] = useState<StatusNotice>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setNotice(null);

    try {
      await login(username, password);
      navigate('/');
    } catch (err: any) {
      if (err.code === 'pending' || err.code === 'rejected') {
        setNotice({ kind: err.code, reason: err.reason });
      } else {
        setError(err.message || 'Login xatosi');
      }
    }
  };

  return (
    <AuthShell
      title="Xush kelibsiz"
      subtitle="Amanah hisobingizga kiring"
      footer={
        <>
          Hisobingiz yo'qmi?{' '}
          <Link to="/register" className="text-primary-800 font-semibold">
            Ro'yxatdan o'tish
          </Link>
        </>
      }
    >
      {shownError && <AuthAlert tone="error">{shownError}</AuthAlert>}

      {notice?.kind === 'pending' && (
        <AuthAlert tone="warning" icon={Clock} title="Arizangiz ko'rib chiqilmoqda">
          Admin tasdiqlagach tizimga kira olasiz. Iltimos, kuting.
        </AuthAlert>
      )}

      {notice?.kind === 'rejected' && (
        <AuthAlert tone="error" icon={XCircle} title="Arizangiz rad etildi">
          {notice.reason && <>Sabab: {notice.reason}</>}
        </AuthAlert>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        <AuthField
          id="username"
          label="Login"
          icon={User}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Foydalanuvchi nomi"
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          enterKeyHint="next"
          required
        />

        <PasswordField
          id="password"
          label="Parol"
          icon={Lock}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Parolingiz"
          autoComplete="current-password"
          enterKeyHint="go"
          required
        />

        <div className="pt-2">
          <AuthButton loading={isLoading} loadingText="Kirilmoqda...">
            Kirish
          </AuthButton>
        </div>
      </form>
    </AuthShell>
  );
};
